import React from "react";
import { Card, PlusIcon, Title, Subtitle, Link, Spinner, LoadingOverlay } from "./styles";
import plusIcon from "../../../../../assets/icons/add-bold.svg";
import { connect } from "react-redux";
import { Group } from "../../../../../types";
import Icon from "../../../../../components/Icon";

interface ComponentProps {
  group: Group
  groupStates: {
    loading: boolean;
    success: boolean;
    error: string | boolean;
  }
}

const Component: React.FC<ComponentProps> = ({
  group,
  groupStates
}) => {
  return (
    <Card>
      <Link to={`/dashboard/community/${group?.id}/lead-magnets/new`}>
        <PlusIcon>
          <Icon icon={plusIcon} size="28px" color={"black"} />
        </PlusIcon>
        <Title>Crea un nuevo Lead Magnet</Title>
        <Subtitle>Atrae nuevos potenciales clientes</Subtitle>
      </Link>

      {groupStates.loading && (
        <LoadingOverlay>
          <Spinner />
          <Title style={{ marginTop: '20px' }}>Cargando...</Title>
        </LoadingOverlay>
      )}
    </Card>
  );
};

const state = ({ groupStore }) => {
  const { data: group, states: groupStates } = groupStore.group;

  return {
    group,
    groupStates,
  };
};

export default connect(state)(Component);
